import { Injectable } from '@angular/core';
import { EndpointService, DataService } from '.';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class PbiService {
  constructor(
    private endpointService: EndpointService,
    private dataService: DataService<any>
  ) {}

  public getEmbedInfo(dashboard): Observable<any> {
    const endpoint = this.endpointService.getEndpoint('getPbiEmbedInfo', dashboard);

    return this.dataService.getAll(endpoint).pipe(
      map((response: any) => response?.result ?? response)
    );
  }

  public refreshDataSource(): Observable<any> {
    const endpoint = this.endpointService.getEndpoint('dataSourceStatus');
    return this.dataService.getAll(endpoint).pipe(map((response: any) => response.result));
  }
}
